import { FC, useState } from "react";
import { GridSelectorModalWindow } from "../modalWindows/GridSelectorModalWindow";
import { DefaultGrid } from "../grids/default/defaultGrid";
import { IEntitySimpleDTO } from "../../libs/coreapi-dto/@types/common";
import useGridFilter from "../../system/hooks/useGridFilter";
import styles from "../modalWindows/styles/BaseModalWindow.module.scss";
import DayOfTheWeekPluginSettings from "./DayOfTheWeekPluginSettings";

const daysOfTheWeek: IEntitySimpleDTO[] = [
    { idGlobal: "1", displayName: "Понедельник" },
    { idGlobal: "2", displayName: "Вторник" },
    { idGlobal: "3", displayName: "Среда" },
    { idGlobal: "4", displayName: "Четверг" },
    { idGlobal: "5", displayName: "Пятница" },
    { idGlobal: "6", displayName: "Суббота" },
    { idGlobal: "7", displayName: "Воскресенье" },
];

const DayOfTheWeekSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.gridFilter);
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>(
        (props.selectedEntities ?? []) as IGridRow[],
    );

    const selectedEntities = selectedItems.map(({ idGlobal, displayName }) => ({
        idGlobal,
        displayName,
    } as IEntitySimpleDTO));

    return (
        <GridSelectorModalWindow
            onlyGridDisplayName="Выбор дней недели"
            ok={{ onClick: () => props.ok(selectedEntities) }}
            cancel={{ onClick: props.cancel }}
            modalWindowClassName={styles.modalWindowSmallBase}
        >
            <DefaultGrid
                localData
                singleDirectory
                useUiService={false}
                multipleSelect
                gridId="day-of-the-week-selector-grid"
                data={daysOfTheWeek}
                totalCount={daysOfTheWeek.length}
                selectedItems={selectedItems}
                filter={gridFilter}
                plugin={DayOfTheWeekPluginSettings}
                hiddenPagination={{ hiddenNumberPage: true, hiddenCountRow: true }}
                onMultipleSelect={setSelectedItems}
                onSort={(column) => dispatchGridFilter({ type: "sort", payload: column.propertyName })}
                onFilterDelete={(column) => dispatchGridFilter({
                    type: "deleteColumnFilter",
                    payload: column.propertyName,
                })}
                onPageNumberChange={(pageNumber) => dispatchGridFilter({
                    type: "changePageNumber",
                    payload: { pageNumber },
                })}
                onNumberPerPageChange={(numberPerPage) => dispatchGridFilter({
                    type: "changeNumberPerPage",
                    payload: { numberPerPage },
                })}
            />
        </GridSelectorModalWindow>
    );
};

export default DayOfTheWeekSelectorModal;
